<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listDependents"
        sort-name="nome"
        title-table="Dependentes"
        module="dependentAdministrativeModule"
        :show-btn-add="verificarPermissao('ROLE_ADMIM_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_ADMIM_DELETAR')"
        @add="addNew"
        @edit="edit"
      />
      <form-insert
        v-else
        :title-form="objectFormInsert.titleForm"
        :combo-type="comboTypesRegister"
        :show-cpf-associado="showCpfAssociado"
        :eh-associado="ehAssociado"
        :show-btn-add="verificarPermissao('ROLE_ADMIM_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_ADMIM_DELETAR')"
        @cancelar="cancelar"
        @save="save"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "vuex";
import TableComponents from "@/layouts/components/TableComponents.vue";
import { BRow, BCol } from "bootstrap-vue";
import mixinsGlobal from "@/mixins";
import FormInsert from "@/layouts/components/FormInsert.vue";

export default {
  name: "Depedentes",
  components: {
    BRow,
    BCol,
    TableComponents,
    FormInsert,
  },
  mixins: [mixinsGlobal],
  computed: {
    ...mapState("dependentAdministrativeModule", {
      listDependents: (state) => state.listDependents,
      depedent: (state) => state.depedent,
      comboTypesRegister: (state) => state.comboTypesRegister,
    }),
  },
  data() {
    return {
      ehAssociado: false,
      showCpfAssociado: true,
      showForm: false,
      columns: [
        {
          label: "Matricula",
          field: "matricula",
        },
        {
          label: "Nome",
          field: "nome",
        },
        {
          label: "Tipo Registro",
          field: "tipoRegisto",
        },
        {
          label: "Data Nascimento",
          field: "dataNascimento",
          type: "date",
          dateInputFormat: "yyyy-MM-dd",
          dateOutputFormat: "dd/MM/yyyy",
        },
        {
          label: "CPF",
          field: "cpf",
        },
        {
          label: "Vinculo",
          field: "nomeAssociado",
        },
        {
          label: "Situação",
          field: "situacaoRegistro",
        },
        {
          label: this.$t("Action"),
          field: "action",
        },
      ],
      objectFormInsert: {
        titleForm: "Cadastro de Depedente",
      },
      pageConfig: {
        page: 1,
        size: 10,
        sort: "nome",
        order: "asc",
      },
    };
  },
  mounted() {
    this.$store.dispatch(
      "dependentAdministrativeModule/loadComboTypesRegister"
    );
  },
  methods: {
    addNew() {
      this.showForm = true;
      this.showCpfAssociado = true;
      this.ehAssociado = false;
    },
    edit(data) {
      this.$router.push({ path: `editDependent/${data.id}` });
    },
    cancelar() {
      this.$store.dispatch("dependentAdministrativeModule/resetDependent");
      this.showForm = false;
    },
    async save(data) {
      try {
        const associadoVinculo = await this.$store.dispatch(
          "dependentAdministrativeModule/getAssocianteForCpf",
          data.associado
        );
        data.associado = associadoVinculo.data.id;
        const response = await this.$store.dispatch(
          "dependentAdministrativeModule/insertNewDependent",
          data
        );
        this.showMessageSuccess("Salvo", "Incluido com sucesso!");
        this.cancelar();
        this.edit(response.data);
      } catch (error) {
        const errorMsg = error.response?.data?.message || 'Erro ao Inserir'
        this.MensagemError('Falha ao Inserir', errorMsg)
        this.showForm = true
      }
    },
  },
};
</script>
